import axios from "axios";

export const fetchRemote = <S>(url: string): Promise<S> => {
    return axios.get<S>(url).then((e) => {
        return e.data;
    });
};
